'use strict';

require('./anchorSmoothScroll');
require('./braintreeService');
require('./fakeHttp');
require('./httpAPI');
require('./loginRedirect');
require('./multiStepsService');
require('./timeService');
